
// Shared state
let results = {};

export function getState() {
  return results;
}

export function setState(data) {
  results = data;
}

